import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import InPlayer from '../backend/inplayer';

const FreeRoute =  ({ component: Component, ...rest }) => {
  
    
    return (
        <Route
          {...rest}
          render={props =>
              !InPlayer.Account.isAuthenticated() ? (
              <Component {...props} />
            ) : (
              <Redirect to={{ pathname: '/'+props.match.params.AppId+'/home', state: { from: props.location } }} />
            )
          }
        />
      )
};

export default FreeRoute;